import { IsEnum, IsNotEmpty, IsNumber, IsOptional } from 'class-validator';
import { ApiProperty } from '@nestjs/swagger';
import { CategoryEnum } from '@gtpl/shared-models/masters';
export class HistoryDTO {
    @ApiProperty()
    @IsNotEmpty({ message: "Plant Id should not be empty" })
    @IsNumber()
    plantId: number;

    @ApiProperty({
        enum: CategoryEnum
    })
    @IsNotEmpty({ message: "Category should not be empty" })
    @IsEnum(CategoryEnum)
    category: CategoryEnum;

    @ApiProperty()
    @IsNotEmpty({ message: "Category Id should not be empty" })
    categoryId: string;

    @ApiProperty()
    @IsNotEmpty({ message: "Associate RFIS's should not be empty" })
    assocRfId: string;

    @ApiProperty()
    @IsOptional()
    expiryDate: Date;

    @ApiProperty()
    @IsOptional()
    createdUser: string;
}